import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar, Pie } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

const DashboardCharts = ({ stats }) => {

  console.log("DASHBOARD DATA:", stats); // 🔥 DEBUG
  const { t, i18n } = useTranslation();
  const formatChartNumber = (value) => {
    return i18n.language === "ar"
      ? new Intl.NumberFormat("ar-QA").format(value)
      : value;
  };

  // ---------------- MONTHLY SPEND ----------------
  const spendData = {
    labels:
      stats?.monthly_spend?.map((m) =>
        i18n.language === "ar"
          ? (m.month_ar || m.month)
          : m.month
      ) || [],
    datasets: [
      {
        label: t("resmonthly_spend_label"),
        data: stats?.monthly_spend?.map(m => m.total_spent) || [],
        borderColor: "#28a745",
        backgroundColor: "rgba(40,167,69,0.2)",
        tension: 0.4,
      },
    ],
  };


  // ---------------- ORDERS ----------------
  const ordersData = {
    labels:
      stats?.monthly_orders?.map((m) =>
        i18n.language === "ar"
          ? (m.month_ar || m.month)
          : m.month
      ) || [],
    datasets: [
      {
        label: t("resorders"),
        data: stats?.monthly_orders?.map(m => m.total_orders) || [],
        backgroundColor: "#ff7a00",
      },
    ],
  };

  // ---------------- TOP SUPPLIERS ----------------
  const supplierData = {
    labels:
      stats?.supplier_spend?.map((s) =>
        i18n.language === "ar"
          ? (s.company_name_arabic || s.company_name_english)
          : s.company_name_english
      ) || [],

    datasets: [
      {
        label: t("resamount_qar"),
        data: stats?.supplier_spend?.map((s) => s.total_spent) || [],
        backgroundColor: "#007bff",
        yAxisID: "y",
      },
      {
        label: t("resorders"),
        data: stats?.supplier_spend?.map((s) => s.total_orders) || [],
        backgroundColor: "#28a745",
        yAxisID: "y1",
      },
    ],
  };

  // ---------------- ORDER STATUS ----------------
  const statusData = {
    labels:
      stats?.order_status?.map((s) => {
        const statusMap = {
          PLACED: "تم الطلب",
          PENDING: "قيد الانتظار",
          CONFIRMED: "تم التأكيد",
          PREPARING: "قيد التحضير",
          READY: "جاهز",
          OUT_FOR_DELIVERY: "خرج للتوصيل",
          DELIVERED: "تم التوصيل",
          CANCELLED: "تم الإلغاء",
          ACCEPTED: "تم القبول",
          PACKED: "تم التعبئة",
          REJECTED: "مرفوض",
        };

        return i18n.language === "ar"
          ? (statusMap[s.status] || s.status)
          : s.status;
      }) || [],
    datasets: [
      {
        data: stats?.order_status?.map(s => s.count) || [],
        backgroundColor: ["#ffc107", "#28a745", "#dc3545", "#17a2b8"],
      },
    ],
  };

  return (
    <div className="row mt-4">

      {/* MONTHLY SPEND */}
      <div className="col-lg-6">
        <div className="card" id="tour-monthly-spent">
          <div className="card-header">
            <h5>{t("resmonthly_spend")}</h5>
          </div>
          <div className="card-body">
            <Line
              data={spendData}
              options={{
                scales: {
                  y: {
                    ticks: {
                      callback: (value) => formatChartNumber(value),
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* ORDERS */}
      <div className="col-lg-6">
        <div className="card" id="tour-Orders-overview">
          <div className="card-header" >
            <h5>{t("resorders_overview")}</h5>
          </div>
          <div className="card-body">
            <Bar
              data={ordersData}
              options={{
                scales: {
                  y: {
                    ticks: {
                      callback: (value) => formatChartNumber(value),
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* TOP SUPPLIERS */}
      <div className="col-lg-6 mt-4">
        <div className="card" id="tour-Top-suppliers">
          <div className="card-header">
            <h5>{t("restop_suppliers")}</h5>
          </div>
          <div className="card-body">
            <Bar
              data={supplierData}
              options={{
                responsive: true,
                scales: {
                  y: {
                    type: "linear",
                    position: "left",
                    ticks: {
                      callback: (value) => formatChartNumber(value),
                    },
                    title: {
                      display: true,
                      text: t("resamount_qar"),
                    },
                  },
                  y1: {
                    type: "linear",
                    position: "right",
                    ticks: {
                      callback: (value) => formatChartNumber(value),
                    },
                    grid: {
                      drawOnChartArea: false,
                    },
                    title: {
                      display: true,
                      text: t("resorders"),
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* ORDER STATUS */}
      <div className="col-lg-6 mt-4">
        <div className="card" id="tour-Order-status">
          <div className="card-header">
            <h5>{t("resorder_status")}</h5>
          </div>
          <div className="card-body">
            <Pie
              data={statusData}
              options={{
                plugins: {
                  tooltip: {
                    callbacks: {
                      label: (context) => {
                        return `${context.label}: ${formatChartNumber(context.raw)}`;
                      },
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      </div>

    </div>
  );
};

export default DashboardCharts;